// extracted by mini-css-extract-plugin
export default {"main":"TYUb8aOE4LQLIymIzHr1","mainTitle":"HCSvzhSAYPWNOE73bD5N","table":"QvX944isfzDkbP5BJpjx","content":"eEuLJ6kHahSF3c_zgArl"};